// See app/views/layouts/_config_js.html.erb and app/assets/javascripts/config/routes.js
export default window.Routes || {};
